import request from '@/utils/request.js';

// 新增商品类目
export const addBizCategory = (formData) => {
    return request.post(`/biz-category/add`, formData)
}

// 商品类目树
export const listBizCategoryTree = (formData) => {
    return request.get(`/biz-category/tree`, formData)
}

// 商品类目详情
export const detailBizCategory = (bizCategoryId) => {
    return request.get(`/biz-category/get/${bizCategoryId}`)
}

// 修改商品类目
export const updateBizCategory = (updateData) => {
    return request.put(`/biz-category/update`, updateData)
}

// 删除商品类目
export const deleteBizCategory = (bizCategoryId) => {
    return request.delete(`/biz-category/delete/${bizCategoryId}`)
}

// 修改商品类目上下架状态
export const updateBizCategoryState = (updateData) => {
    return request.put(`/biz-category/state/update/${updateData.bizCategoryId}?state=${updateData.state}`)
}

// 批量更新商品类目排序
export const updateBizCategorySort = (updateData) => {
    return request.put(`/biz-category/sort`, updateData)
}
